import { ResponsiveDialog, useTranslation } from '@diagentech/exprworks-ui-components';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { useCallback, useEffect } from 'react';

import { theme } from '@/App/theme';
import { DefaultFormButton } from '@/components/common/DefaultFormButton';
import { AboutAuthorContent } from '@/components/info/AboutAuthorContent';
import { IntroContent } from '@/components/info/IntroContent';

interface InfoDialogProps {
  open: boolean;

  onClose(): void;
}

const INTRO_TAB = '1';
const ABOUT_AUTHOR_TAB = '2';

export const INFO_DIALOG_ID = 'info-dialog';

export const InfoDialog: React.FC<InfoDialogProps> = ({ open, onClose }) => {
  const [tabValue, setTabValue] = React.useState(INTRO_TAB);
  const [visible, setVisible] = React.useState(false);

  useEffect(() => {
    if (open) {
      setTabValue(INTRO_TAB);
      setVisible(true);
    }
  }, [open]);

  const handleTabChange = useCallback((_: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  }, []);

  const tabPanelProps = {
    sx: {
      padding: '8px 0 0 16px',
    },
  };

  const introLabel = useTranslation('SH.PG.INTRO');
  const aboutAuthorLabel = useTranslation('SH.PG.ABOUTAUTHOR');
  const tabsAriaLabel = useTranslation('SH.ARIA.INFOTABS');

  return (
    <ResponsiveDialog
      id={INFO_DIALOG_ID}
      theme={theme}
      breakpoints={{ maxWidth: 'lg' }}
      fullWidth
      open={open}
      onClose={onClose}
      {...(!visible ? { sx: { display: 'none' } } : {})}
      slotProps={{
        paper: {
          'aria-label': tabValue === INTRO_TAB ? introLabel : aboutAuthorLabel,
        },
      }}
    >
      <DialogContent
        style={{
          minHeight: '87vh',
          maxHeight: '90vh',
          padding: '0 16px',
        }}
      >
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label={tabsAriaLabel}>
              <Tab label={introLabel} value={INTRO_TAB} />
              <Tab label={aboutAuthorLabel} value={ABOUT_AUTHOR_TAB} />
            </TabList>
          </Box>
          <TabPanel value={INTRO_TAB} {...tabPanelProps}>
            <IntroContent />
          </TabPanel>
          <TabPanel value={ABOUT_AUTHOR_TAB} {...tabPanelProps}>
            <AboutAuthorContent />
          </TabPanel>
        </TabContext>
      </DialogContent>
      <DialogActions>
        <DefaultFormButton id="SH.BTN.CLOSE" color="primary" onClick={onClose} />
      </DialogActions>
    </ResponsiveDialog>
  );
};
